interface GalleryVirtualTourProps {
  virtualTourData: string;
}

import { ModalInnerWrapper } from './styles';

const GalleryVirtualTour = ({ virtualTourData }: GalleryVirtualTourProps) => {
  return (
    <ModalInnerWrapper>
      <iframe
        width="100%"
        height="100%"
        src={virtualTourData}
        frameBorder="0"
        allowFullScreen
        allow="xr-spatial-tracking"
      ></iframe>
    </ModalInnerWrapper>
  );
};

export default GalleryVirtualTour;
